export const validateQuestion = (question) => {
  if (question.title === "")
    return { status: false, message: "Ingrese el Titulo" };
  if (question.content === "")
    return { status: false, message: "Ingrese el Contenido" };

  return { status: true, message: "" };
};
